import React from 'react'
import SystemConfiguration from "../SystemConfiguration/SystemConfiguration.js";
import '../WorkflowSettingsHome/WorkflowSettingsHome.css'
import { useNavigate } from 'react-router-dom';
const WorkflowSettingsHome = () => {
    const navigate=useNavigate();
     const HideTheQueueMangementsanEnv = process.env.REACT_APP_FLAG_SAN;
  return (
    <>
    <h4 className="speciality-header-text">Workflow Settings</h4>
    <div className='settings-card-wrapper'>
       <div className='settings-cards' onClick={()=>navigate('/System-configuration')}>
            <span>Queue Management</span>
            <span>Configure and manage coding queues used to organize tasks or cases. Queues act as categories that coders can create, assign to users, and use to streamline task distribution and tracking. Customize queue access, assignment rules, and priorities to match your team's workflow</span>
        </div>
        <div className='settings-cards' onClick={()=>navigate('/User-Management')}>
            <span>User Management</span>
            <span>Manage all system users in one place.View detailed information such as Clinical Speciality, expertise, roles and status. Easily update user profiles and control access to ensure secure and efficient operations.</span>
        </div>
        <div className='settings-cards' onClick={()=>navigate('/User-Availability')}>
            <span>Leave Allocation</span>
            <span>Track and manage user time-off, holidays, and availability. Ensure smooth workflow planning by monitoring team capacity and scheduling leave requests effectively.</span>
        </div>
        {/* <SystemConfiguration/> */}
    </div>
    </>

  )
}

export default WorkflowSettingsHome
